import {ReactSketchCanvas} from "react-sketch-canvas";
import {useEffect, useRef, useState} from "react";
import DarkPen from '../../images/icons/dark-pen.svg'
import YellowPen from '../../images/icons/yellow-pen.svg'
import DarkEraser from '../../images/icons/dark-eraser.svg'
import YellowEraser from '../../images/icons/yellow-eraser.svg'
import Image from 'image-js';
import {CompactPicker} from "@hello-pangea/color-picker";
import ToggleInput from "./ToggleInput";
import Logo from "../../images/logo_light_grey.png";

export default function DrawingInput(props) {
    const [isSaving, setIsSaving] = useState(false);
    const [referenceImage, setReferenceImage] = useState(null);
    const [invertMask, setInvertMask] = useState(false);
    const [strokeWidth, setStrokeWidth] = useState(5);
    const [brushColor, setBrushColor] = useState('#000000');
    const [brushMode, setBrushMode] = useState('brush');
    const [isMask, setIsMask] = useState(false);
    const [width, setWidth] = useState(0);    // numbers
    const [height, setHeight] = useState(0);
    const [ready, setReady] = useState(false);
    const [zoom, setZoom] = useState(0);
    const canvas = useRef(null)

    useEffect(() => {
        // This useEffect is no longer needed since we handle saving directly in saveImage()
        // Keeping it empty to avoid breaking anything that might depend on the state changes
    }, [canvas, referenceImage, isSaving])

    useEffect(() => {
        new Image.load(props.image).then(image => {
           // Constrain to max dimensions while maintaining aspect ratio
           const maxWidth = 800;
           const maxHeight = 600;
           let newWidth = image.width;
           let newHeight = image.height;
           
           // Calculate scaling factor to fit within max dimensions
           if (image.width > maxWidth || image.height > maxHeight) {
               const widthRatio = maxWidth / image.width;
               const heightRatio = maxHeight / image.height;
               const scaleFactor = Math.min(widthRatio, heightRatio);
               
               newWidth = Math.round(image.width * scaleFactor);
               newHeight = Math.round(image.height * scaleFactor);
           }
           
           console.log(`[DrawingInput] Original: ${image.width}x${image.height}, Scaled: ${newWidth}x${newHeight}`);
           
           setWidth(newWidth);
           setHeight(newHeight);
           setReferenceImage(props.image);
           setReady(true);
        }).catch(error => {
            console.error('[DrawingInput] Error loading image:', error);
            // Fallback to default size if image loading fails
            setWidth(800);
            setHeight(600);
            setReferenceImage(props.image);
            setReady(true);
        });
    }, [props.image])

    useEffect(() => {
        setIsMask(props.isMask);
        if (props.isMask) {
            setStrokeWidth(50);
            setBrushColor('rgba(225,0,0,0.8)');
        }
    }, [props.isMask]);

    useEffect(() => {

    }, [zoom]);

    const saveImage = () => {
        if (props.isMask) {
            // Temporarily remove background to get just the drawn mask
            const originalRef = referenceImage;
            setReferenceImage(null);
            
            setTimeout(async() => {
                try {
                    const data = await canvas.current.exportImage('png');
                    setReferenceImage(originalRef); // restore immediately
                
                    // 1) Load the PNG the user drew (strokes on transparent bg)
                    let im = await Image.load(data);
                
                    // 2) Take alpha channel (0 where transparent, >0 where user drew)
                    let mask = im.getChannel('a');          // returns an Image
                
                    // 3) Binarize: 0 -> black, >0 -> white
                    mask = mask.mask({ threshold: 1 });     // <- use mask(), not threshold()
                
                    // 4) Optional: user toggle to invert semantics
                    if (invertMask) mask = mask.invert();
                
                    const maskB64 = mask.toBase64('png');
                    props.setImage(maskB64);
                    props.closeEvent();
                  } catch (e) {
                    console.error('[DrawingInput] Error exporting mask:', e);
                    setReferenceImage(originalRef);
                    props.closeEvent();
                  }
                // canvas.current.exportImage('png')
                //     .then(async data => {
                //         // // Restore background immediately
                //         setReferenceImage(originalRef);
                        
                //         // Process the mask - drawn areas should be white, rest black
                //         let maskImage = await Image.load(data);
                //         maskImage = maskImage.grey();
                        
                //         // Ensure the mask is visible - if mostly transparent/white, invert
                //         if (!invertMask) {
                //             maskImage = maskImage.invert();
                //         }
                        
                //         const maskBase64 = maskImage.toBase64('png');
                //         props.setImage(maskBase64);
                //         props.closeEvent();
                //     })
                //     .catch(error => {
                //         console.error('[DrawingInput] Error exporting mask:', error);
                //         setReferenceImage(originalRef);
                //         props.closeEvent();
                //     });
            }, 100);
        } else {
            canvas.current.exportImage('jpeg')
                .then(async data => {
                    let image = await Image.load(data);
                    props.setImage(image.toBase64());
                    props.closeEvent();
                });
        }
    }

    // const saveImage = () => {
    //     if (props.isMask) {
    //         // For masking, we need to export both the mask and keep the original
    //         // First, temporarily hide the background to get just the mask
    //         const originalRef = referenceImage;
    //         setReferenceImage(null);
            
    //         setTimeout(() => {
    //             canvas.current.exportImage('png')
    //                 .then(async maskData => {
    //                     // Convert mask drawing to grayscale mask
    //                     let maskImage = await Image.load(maskData);
    //                     maskImage = maskImage.grey().mask();
    //                     if (!invertMask) {
    //                         maskImage = maskImage.invert();
    //                     }
                        
    //                     // Restore the background
    //                     setReferenceImage(originalRef);
                        
    //                     // Now export the composite for preview
    //                     setTimeout(() => {
    //                         canvas.current.exportImage('png')
    //                             .then(async compositeData => {
    //                                 let compositeImage = await Image.load(compositeData);
                                    
    //                                 // Send both images - composite for preview, mask for API
    //                                 const maskBase64 = maskImage.toBase64('png');
    //                                 const maskWithPrefix = maskBase64.startsWith('data:') ? maskBase64 : `data:image/png;base64,${maskBase64}`;
                                    
    //                                 props.setImage({
    //                                     composite: compositeImage.toBase64('png'),
    //                                     mask: maskWithPrefix,
    //                                     original: props.originalImage || props.image
    //                                 });
    //                                 props.closeEvent();
    //                             }).catch(error => {
    //                                 console.error('[DrawingInput] Error exporting composite:', error);
    //                                 props.closeEvent();
    //                             });
    //                     }, 100);
    //                 }).catch(error => {
    //                     console.error('[DrawingInput] Error exporting mask:', error);
    //                     setReferenceImage(originalRef);
    //                     props.closeEvent();
    //                 });
    //         }, 100);
    //     } else {
    //         canvas.current.exportImage('jpeg')
    //             .then(async data => {
    //                 let image = await Image.load(data);
    //                 props.setImage(image.toBase64());
    //                 props.closeEvent();
    //             });
    //     }
    // }

    console.log('Drawing input size', width, height);

    return (
        <div
            className={"mx-auto flex flex-col items-center justify-center bg-white/50 rounded-lg overflow-hidden shadow-2xl"}
            style={{ maxWidth: '900px' }}
        >
            {ready ? (
                <ReactSketchCanvas
                    ref={canvas}
                    className={"border border-gray-400"}
                    width={width}
                    height={height}
                    strokeWidth={strokeWidth}
                    eraserWidth={strokeWidth}
                    strokeColor={brushColor}
                    backgroundImage={referenceImage ? referenceImage : ""}
                    canvasColor={'transparent'}
                    exportWithBackgroundImage={true}
                    preserveBackgroundImageAspectRatio={"xMidYMid meet"}
                />
            )
            :
                <div className={"mx-auto flex flex-col items-center justify-center bg-dark-blue/50 rounded-lg overflow-hidden shadow-2xl"} style={{maxWidth: '900px'}}>
                    <img src={Logo} alt={"Promptus Logo"} />
                </div>
            }
            <div className={"flex flex-row gap-2 w-full flex-wrap justify-between p-2 items-center bg-white/50 rounded-bl-lg rounded-br-lg text-dark-blue"}>
                {/*<div className={""}>*/}
                {/*    <button className={`text-dark-blue text-2xl p-2 rounded`}><CgZoomIn /></button>*/}
                {/*    <button className={`text-dark-blue text-2xl p-2 rounded`}><CgZoomOut /></button>*/}
                {/*</div>*/}
                <div className={"flex flex-row gap-2"}>
                    <button className={`text-2xl p-2 rounded ${brushMode === "brush" ? "bg-dark-blue" : ""}`} onClick={() => {
                        setBrushMode("brush");
                        canvas.current.eraseMode(false);
                    }}>
                        {brushMode === "brush" ?
                            <img src={YellowPen} className='h-7'/>
                        :
                            <img src={DarkPen} className='h-7'/>    
                        }
                    </button>
                    <button className={`text-2xl p-2 rounded ${brushMode === "erase" ? "bg-dark-blue" : ""}`} onClick={() => {
                        setBrushMode("erase");
                        canvas.current.eraseMode(true);
                    }}>
                        {brushMode === "erase" ?
                            <img src={YellowEraser} className='h-7'/>
                        :
                            <img src={DarkEraser} className='h-7'/>    
                        }
                    </button>
                </div>
                <div className={""}>
                    <label htmlFor="BrushSize"
                           className="w-full flex flex-row gap-4 items-center mb-2 text-sm font-medium">
                        <span>Brush Size</span>
                        <span className={"block flex-grow bg-white px-2 py-1 rounded text-dark-blue text-right"}>{strokeWidth}</span>
                    </label>
                    <input id="BrushSize" type="range" value={strokeWidth} step={5} min={5} max={100} onChange={(e) => setStrokeWidth(Number(e.target.value))}
                           className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none accent-yellow cursor-pointer" />
                </div>
                {!isMask ?
                    <CompactPicker onChange={(color) => setBrushColor(color.hex)} />
                    : <div>
                        <label htmlFor={"invertMask"}>
                            <ToggleInput id={""} checked={invertMask} onChange={() => setInvertMask(!invertMask)} /> Invert Mask
                        </label>
                    </div> }
                <button className={"w-full flex-grow p-2 bg-yellow text-dark-blue rounded font-bold"} onClick={saveImage}>Use {!isMask ? 'Image' : 'Mask'}</button>
            </div>
        </div>
    );
}
